module.exports = __webpack_public_path__ + "static/media/banner@2x.19310862.png";